module.exports = __webpack_public_path__ + "8713f2051450997670331d946a12229d.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/eldar-preview.mp4
// module id = 630
// module chunks = 0